import { InvoiceController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { invoiceStore } from '../../stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import QuotationSummary from '../../pages/Invoice/QuotationSummary';

const QuotationSummaryContainer = ({
	quote,
	closeModal,
	editInvoiceMain,
	editQuoteModal,
	goToEditQuote,
	sendQuotation,
	quotationList,
}) => {
	const [editInvoice, setEditInvoice] = useState(false);
	const [updateInvoice, setUpdateInvoice] = useState(false);

	const goToEditInvoice = () => {
		setEditInvoice(true);
	};
	const goToUpdateInvoice = () => {
		setUpdateInvoice(true);
	};

	const invoice = invoiceStore.selectedInvoice;
	const invoiceItem = invoice.status === constant.TRANSACTION_STATUS.UNPAID;

	const sendInvoice = async id => {
		const { status, errorMessage } = await InvoiceController.sendInvoice(id);
		if (status === constant.Success) {
			return MimaToastUtil.success({
				message: constant.Sent,
			});
		}
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	const onDownload = async invoiceId => {
		const { errorMessage } = await InvoiceController.download(invoiceId);
		if (errorMessage) {
			MimaToastUtil.error({
				message: errorMessage,
			});
		} else {
			MimaToastUtil.success({
				message: constant.Success,
			});
		}
	};
	const updatedCloseModal = () => {
		// closeModal();
		setEditInvoice(false);
		setUpdateInvoice(false);
	};

	return (
		<QuotationSummary
			onDownload={onDownload}
			sendInvoice={sendInvoice}
			sendQuotation={sendQuotation}
			editInvoice={editInvoice}
			goToEditInvoice={goToEditInvoice}
			editInvoiceMain={editInvoiceMain}
			closeModal={closeModal}
			updateInvoice={updateInvoice}
			goToUpdateInvoice={goToUpdateInvoice}
			invoiceItem={invoiceItem}
			editQuoteModal={editQuoteModal}
			goToEditQuote={goToEditQuote}
			quotationList={quotationList}
			quote={quote}
		/>
	);
};

export default observer(QuotationSummaryContainer);
